import getFileExtension from "./getExtension";
import { readFileAsync } from "./readFile";

const File = {
  readFileAsync,
  getFileExtension
};

export default File;
